import React from 'react'
import PropTypes from 'prop-types'
import InfoTooltip from 'components/Utilities/InfoTooltip'
import { handleClickTabPane } from 'common/util'
import { PLAN_NAMES } from 'common/settings'

const ParcelLimitsInfoCard = ({ used, limit, level, hasViewsRemaining }) => {
  const reactMapComponent = window.data?.flags?.react_map_component
  const appConfigLimits =  window.data?.limits

  const handleSignup = (e) => {
    e.preventDefault()
    if(reactMapComponent) {
      handleClickTabPane('signup-signin') // New UI panels for signup + upgrade
    } else {
      window.location = '/plans' // Old UI, either anon or starter
    }
  }

  // Redirects based on plans
  const handleUpgrade = (nextLevel) => {
    const groupPath = window.data?.group?.path || '' // Ensure it's not undefined

    const planRoutes = {
      [PLAN_NAMES.PRO]:  '/plans#p=level1',
      [PLAN_NAMES.TEAM]: `${groupPath}/settings/billing?plan_change=team_flex`,
    }

    window.location = planRoutes[nextLevel] || '/plans'
  }

  const upgradeOptions = {
    [PLAN_NAMES.ANON]: {
      nextLevel:  `free ${PLAN_NAMES.FREE}`,
      limit:      appConfigLimits.antiscrape_free,
    },
    [PLAN_NAMES.FREE]: {
      nextLevel: PLAN_NAMES.PRO,
      limit:     appConfigLimits.antiscrape_pro,
    },
    [PLAN_NAMES.PRO]: {
      nextLevel: PLAN_NAMES.TEAM,
      limit:     appConfigLimits.antiscrape_team,
    },
    [PLAN_NAMES.TEAM]: null,
  }

  const currentUpgradeOption = upgradeOptions[level]
  const upgradeMessage = currentUpgradeOption
    ? `Upgrade to a ${currentUpgradeOption.nextLevel} account to increase your daily limit to ${currentUpgradeOption.limit}, or come back tomorrow when your counter resets.`
    : `Contact support to discuss increasing your daily lookup limits, or come back tomorrow when your counter resets.`

  return (
    <div className="margin-btm-md rounded">
      <div className='centered'>
        <div className="alert plan-color relative">
          {/* Explicit limit reached message */}
          {hasViewsRemaining === false && (
            <div className="parcel-limits">
              <span><strong>Property Lookup Daily Limit Reached</strong></span>
              <InfoTooltip
                id='limits'
                tip={upgradeMessage}
                circleSize="fa-xs"
                place="right"
                type="dark"
                delayShow={250}
                className="parcel-details-tooltip"
              />
            </div>
          )}
          <div>
            <span>
              Property details viewed: <strong>{used} / {limit}</strong>
            </span>

            {[PLAN_NAMES.ANON, PLAN_NAMES.FREE, PLAN_NAMES.PRO, PLAN_NAMES.TEAM].map((accountLevel) => {
              if(level !== accountLevel) return null
              const { nextLevel, limit: nextLimit } = upgradeOptions[accountLevel] || {}

              if(accountLevel === PLAN_NAMES.TEAM && hasViewsRemaining === false) {
                return (
                  <div key={accountLevel} className="small">
                    <span className="small parcel-limits">
                      Please use the ‘Contact Support’ option under the <i className="fas fa-question-circle"></i> button found in the lower right to discuss your options for
                      increased lookups with our friendly Support team, or come back tomorrow when your counter resets.
                    </span>
                  </div>
                )
              }
              if(hasViewsRemaining) {
                return hasViewsRemaining && (
                  <div className="margin-top-sm"  key={accountLevel}>
                    <span className="small">
                      <a
                        href="#"
                        id="limit-signup-link"
                        className="underline"
                        target="_blank"
                        onClick={accountLevel === PLAN_NAMES.ANON
                          ? handleSignup : () => handleUpgrade(nextLevel)
                        }
                      >
                        Get a {nextLevel} account
                      </a>
                    </span>
                    <span className='small'><br />to increase your limit to {nextLimit}/day.</span>
                    <br />
                  </div>
                )
              }

              if(hasViewsRemaining === false) {
                return (
                  <div key={accountLevel}>
                    <div className="centered small">
                      <a
                        className="btn btn-round btn-primary btn-sm"
                        href="#"
                        role="button"
                        target="_blank"
                        id="limit-signup-link"
                        onClick={accountLevel === PLAN_NAMES.ANON ? handleSignup : () => handleUpgrade(nextLevel)}
                      >
                        Upgrade to {nextLevel}
                      </a>
                    </div>
                  </div>
                )
              }

              // return null when hasViewsRemaining is null (loading state)
              return null
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

ParcelLimitsInfoCard.propTypes = {
  hasViewsRemaining: PropTypes.bool,              // may be passed as null
  used:              PropTypes.string.isRequired, // passed as String(used)
  limit:             PropTypes.number.isRequired,
  level:             PropTypes.string.isRequired,
}

export default ParcelLimitsInfoCard
